import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { ContratadosForm } from "../modais"
import Layout from "../Layout"
class ContratadosCreateForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/contratados")
  }
  render() {
    return (
      <Layout tabActive="Contratados">
        <ContratadosForm callBackContratados={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(ContratadosCreateForm)



// WEBPACK FOOTER //
// ./src/views/contratados/ContratadosCreateForm.js